import {
  UnisatConnector,
  // BybitConnector,
  //  WizzConnector,
  BaseConnector,
} from '@particle-network/btc-connectkit';

import { NetworkNet } from '@/networks/btc-like/common';
import { isMobile } from '@/utils/misc';

import { NETWORK } from '../../constants';
import {
  // ExodusConnector,
  XverseConnector,
  OKXConnector,
  //  BitgetConnector,
  //   TokenPocketConnector
} from '../connectors';
import { PGWalletConnector } from '../connectors/PGWalletConnector';

const pgWallet: () => BaseConnector[] = () => [new PGWalletConnector()];

const mobileWallets: () => BaseConnector[] = () => [
  new XverseConnector(true),
  new OKXConnector(true),
  // new BitgetConnector(true),
  // new TokenPocketConnector(true),
];

const desktopWallets: () => BaseConnector[] = () => [
  new XverseConnector(false),
  new UnisatConnector(),
  new OKXConnector(false),
  // new ExodusConnector(),
  // new BitgetConnector(false),
  // new BybitConnector(),
  // new WizzConnector(),
];

const mobileTestnetWallets: () => BaseConnector[] = () => [
  new XverseConnector(true),
  new OKXConnector(true),
  //  new BitgetConnector(true)
];

const desktopTestnetWallets: () => BaseConnector[] = () => [
  new XverseConnector(false),
  new UnisatConnector(),
  new OKXConnector(false),
  // new BitgetConnector(false),
  // new WizzConnector(),
];

// Important! Construct wallets conditionally due to events streams
export const getMainnetWallets = location.pathname.includes('pg-wallet')
  ? pgWallet
  : isMobile()
    ? mobileWallets
    : desktopWallets;

export const getTestnetWallets = isMobile() ? mobileTestnetWallets : desktopTestnetWallets;

export const getWallets = () => {
  return NETWORK.Network === NetworkNet.Mainnet ? getMainnetWallets() : getTestnetWallets();
};
